import {FC} from 'react';

import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

import {formatPriceWithCurrency} from 'utils';

import {PriceCrossed} from './styles';
import {StyledDeliveryFee} from './styles';

export interface BasketDeliveryFeeProps {
  currentShippingFee: number;
  defaultShippingFee?: number;
  priceUnit: string;
  displayFeeId?: string;
  originalFeeId?: string;
  isStorePickupSelected?: boolean;
}

export const BasketDeliveryFee: FC<BasketDeliveryFeeProps> = ({
  currentShippingFee,
  defaultShippingFee,
  priceUnit,
  originalFeeId,
  displayFeeId,
  isStorePickupSelected
}) => {
  if (currentShippingFee && defaultShippingFee && currentShippingFee < defaultShippingFee) {
    return (
      <Box display="flex" alignItems="center" textAlign="center">
        <PriceCrossed id={originalFeeId}>{formatPriceWithCurrency(defaultShippingFee as any, priceUnit)}</PriceCrossed>
        &nbsp;
        <StyledDeliveryFee id={displayFeeId}>
          {formatPriceWithCurrency(currentShippingFee, priceUnit)}
        </StyledDeliveryFee>
      </Box>
    );
  }
  if (currentShippingFee === 0 && (!isStorePickupSelected || !defaultShippingFee)) {
    return (
      <Box display="flex" alignItems="center">
        {!!defaultShippingFee && (
          <>
            <PriceCrossed id={originalFeeId}>
              {formatPriceWithCurrency(defaultShippingFee as any, priceUnit)}
            </PriceCrossed>
            &nbsp;
          </>
        )}
        <Typography id={displayFeeId} fontSize="0.8rem" color="primary" fontWeight={700}>
          {t('label.free')}
        </Typography>
      </Box>
    );
  }

  return (
    <StyledDeliveryFee id={displayFeeId}>{formatPriceWithCurrency(currentShippingFee, priceUnit)}</StyledDeliveryFee>
  );
};

BasketDeliveryFee.displayName = 'BasketDeliveryFee';
